import { imageUuid } from 'editor/src/store/gallery/reducer/addImageReducer';
import { UploadedImageData } from 'editor/src/store/gallery/types';
import toGalleryImages from 'editor/src/store/gallery/utils/toGalleryImages';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import { setLibraryImagesAction } from '../slice';
import isUploadedImageData from '../utils/isUploadedImageData';

let latestCall = 0;

/** Handles `gallery.setLibrary`: replaces the customer's saved images and turns the library on. */
const setLibraryOperation =
  (payload: { images?: UploadedImageData[] } | undefined) => async (dispatch: ThunkDispatch) => {
    latestCall += 1;
    const call = latestCall;
    const inputImages = Array.isArray(payload?.images) ? payload.images.filter(isUploadedImageData) : [];
    const images = await toGalleryImages(inputImages);
    // dimensions load asynchronously, so an older list can finish after a newer one
    if (call !== latestCall) {
      return;
    }
    dispatch(setLibraryImagesAction(images.map((image) => ({ ...image, uuid: imageUuid.generate() }))));
  };

export default setLibraryOperation;
